"use client";

import { useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import "./Layout.css";

export default function Layout({ children }) {

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const user = {
    name: "Admin User",
    role: "admin" // change to "user" if normal user
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="dashboard">

      <Sidebar
        role={user.role}
        isOpen={sidebarOpen}
        onClose={closeSidebar}
      />

      <div className="main">

        <Topbar toggleSidebar={toggleSidebar} />

        <div className="content">
          {children}
        </div>

      </div>

    </div>
  );
}